import { RebateOrOfferType } from 'src/components/Microsite/FindItDuke/OffersAndRebates';
import { getJson } from 'src/components/Microsite/FindItDuke/api/getJson';
import { GetRebatesInterface } from '../../../types';

const getRebatesUrl =
  'https://sc10dev07-cd.duke-energy.com/-/media/json/find-it-duke/offers-and-rebates/rebate-data.json';

const rebatesMap: { [key: string]: string } = {
  'Replacement Systems': 'HVAC',
  'Water Heater Replacement': 'HEAT PUMP WATER HEATER',
  'Attic Insulation & Air Sealing': 'ATTIC INSULATE AND SEAL',
  'Duct Repair & Sealing': 'SEAL DUCTWORK',
  'Pump Replacement': 'POOL PUMP',
};

export const getRebates = async ({
  jurisdiction,
  service,
  value,
  rebatesUrl,
  setRebates,
  setRebateModalIsOpen,
  handleFormSubmit,
}: GetRebatesInterface) => {
  // rebatesUrl can come from Sitecore if data is added
  const rebates = await getJson(rebatesUrl || getRebatesUrl);
  let rebatesInJurisdiction = [];

  if (rebates) {
    rebatesInJurisdiction = rebates[jurisdiction];
  }

  const relatedRebates = rebatesInJurisdiction
    ? rebatesInJurisdiction.filter(
        (rebate: RebateOrOfferType) => rebate!.rebate === rebatesMap[service.header]
      )
    : [];

  // only show rebates modal if there are related rebates, otherwise submit form and generate contractor results
  if (relatedRebates.length > 0) {
    setRebates(relatedRebates);
    setRebateModalIsOpen(true);
  } else {
    handleFormSubmit(value);
  }
};
